import {
  DialogContent,
  FormTextarea,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Typography,
  FormSelect,
  Loading,
  Button,
  Dialog,
  Input,
  Form,
} from '@ui/components';
import { SendApplicationRequest } from '@interfaces/models';
import { useHelpContent } from '@pages/help/hooks';
import { useTranslation } from 'react-i18next';
import { useCurrentUser } from '@shared/hooks';
import * as React from 'react';

import { useSendApplicationModal, SendApplicationForm } from './use-send-application-modal';

interface SendApplicationModalProps {
  onOpenChange: (value: boolean) => void;
  open: boolean;
}

export const SendApplicationModal: React.FC<SendApplicationModalProps> = (props) => {
  const { user } = useCurrentUser();
  const { t } = useTranslation();

  const { supportTicketSubjects, isSupportTicketSubjectsLoading } = useHelpContent();

  const subjectOptions =
    supportTicketSubjects?.data.map((ticket) => ({
      label: ticket.subject,
      value: ticket.subjectId,
    })) ?? [];

  const onClose = () => {
    props.onOpenChange(false);
    form.reset();
  };

  const { form, onSubmit, isLoading } = useSendApplicationModal({
    onSuccess: () => onClose(),
  });

  const handleSubmit = (data: SendApplicationForm) => {
    const topicTitle = supportTicketSubjects?.data.find(
      (subject) => subject.subjectId === data.topicId,
    )?.subject;

    const payload = {
      content: data.content,
      titleId: data.topicId,
      title: topicTitle!,
    };

    // API types are broken here, there is no guarantee that titleId is a number
    onSubmit(payload as unknown as SendApplicationRequest);
  };

  return (
    <Dialog onOpenChange={onClose} open={props.open}>
      <DialogContent>
        <DialogHeader className="p-4">
          <DialogTitle>
            <Typography variant="h300">{t('HELP.SUBMIT_APPLICATION')}</Typography>
          </DialogTitle>
        </DialogHeader>
        <Loading isLoading={isSupportTicketSubjectsLoading}>
          <Form {...form}>
            <div className="space-y-4 p-4">
              <Input
                placeholder={t('HELP.SEND_APPLICATION_NAME_SURNAME')}
                value={`${user?.firstName} ${user?.lastName}`}
                name="nameSurname"
                inputSize="large"
                hasShadow
                required
                disabled
                floating
              />

              <FormSelect
                placeholder={t('HELP.SEND_APPLICATION_APPLICATION_TOPIC')}
                componentProps={{ hasShadow: true }}
                formControl={form.control}
                options={subjectOptions}
                name="topicId"
                size="large"
                required
                floating
              />

              <FormTextarea
                componentProps={{ rows: 8, hasShadow: true }}
                placeholder={t('HELP.APPLICATION_CONTENT')}
                formControl={form.control}
                name="content"
                required
                floating
              />
            </div>
          </Form>
          <DialogFooter className="flex items-center justify-between">
            <Button
              onClick={form.handleSubmit(handleSubmit)}
              isLoading={isLoading}
              disabled={isLoading}
              size="large"
              wide
            >
              {t('HELP.SUBMIT_APPLICATION')}
            </Button>
          </DialogFooter>
        </Loading>
      </DialogContent>
    </Dialog>
  );
};
